/*# sourceMappingURL=ips-view.component-62VOHDGB.css.map */
